module.exports = __webpack_public_path__ + "img/47.6.CODm.60aeb8a3.png";